import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationEs = () => {
  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>Normas de la Comunidad de pregnancy&baby</PolicyTitle>
      <PolicyVersion>
        Fecha de entrada en vigor: 21 de septiembre de 2026
        <br />
        Última actualización: 25 de agosto de 2026
      </PolicyVersion>

      <PolicyText>
        Estas Normas de la Comunidad (en adelante, las “Normas”) establecen las
        reglas y criterios aplicables al uso de las funciones de comunidad de{" "}
        <strong>pregnancy&baby</strong>, un servicio operado por Connecti Co.,
        Ltd. (en adelante, la “Empresa”, “nosotros” o “nuestro”).
      </PolicyText>
      <PolicyText>
        La comunidad de pregnancy&baby es un espacio en el que las personas
        usuarias pueden compartir experiencias, inquietudes, preguntas e
        información sobre la preparación para el embarazo, los tratamientos de
        fertilidad, el embarazo, el parto, la crianza y otros temas
        relacionados.
      </PolicyText>
      <PolicyText>
        Queremos que pregnancy&baby sea un espacio seguro y respetuoso en el que
        las personas usuarias puedan comunicarse libremente y apoyarse
        mutuamente. Por ello, le rogamos que lea y respete estas Normas cuando
        utilice las funciones de comunidad.
      </PolicyText>
      <PolicyText>
        Estas Normas complementan los{" "}
        <strong>Términos de Uso de pregnancy&baby</strong>. Si una actividad
        infringe la legislación aplicable, los Términos de Uso o estas Normas,
        la Empresa podrá adoptar las medidas oportunas, incluida la restricción
        o eliminación de contenidos y la limitación del acceso a determinadas
        funciones de la comunidad.
      </PolicyText>
      <PolicyText>
        La Empresa podrá actualizar estas Normas cuando resulte necesario para
        mantener un entorno seguro y adecuado. Los cambios sustanciales se
        comunicarán previamente a través del Servicio de conformidad con los
        Términos de Uso y la legislación aplicable.
      </PolicyText>

      <PolicySectionTitle>1. Tu perfil te representa</PolicySectionTitle>
      <PolicyText>
        El nombre de usuario o apodo y la imagen de perfil ayudan a que otras
        personas usuarias puedan reconocerte dentro de la comunidad.
      </PolicyText>
      <PolicyText>
        Utiliza información de perfil adecuada y que no induzca a error sobre tu
        identidad.
      </PolicyText>
      <PolicyText>
        El perfil podrá ser restringido o podrá solicitarse su modificación
        cuando:
      </PolicyText>
      <PolicyHyphenList>
        <li>Contenga material inapropiado, ofensivo, obsceno o ilícito; </li>
        <li>
          Utilice sin autorización el nombre, marca, logotipo, imagen u otro
          material protegido perteneciente a otra persona u organización;{" "}
        </li>
        <li>
          Suplante la identidad de otra persona, empresa, organización, miembro
          del equipo o administrador de pregnancy&baby; o{" "}
        </li>
        <li>
          Pueda inducir a error o generar confusión entre otras personas
          usuarias.
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Publicaciones en la comunidad</PolicySectionTitle>
      <PolicyText>
        Los contenidos publicados en la comunidad de pregnancy&baby podrán ser
        visibles para otros miembros.
      </PolicyText>
      <PolicyText>
        Antes de publicar, comprueba que tu publicación, comentario, imagen u
        otro contenido no incluya datos personales, información privada o
        información sensible que no desees compartir con otras personas.
      </PolicyText>
      <PolicyText>
        Todas las publicaciones, comentarios, datos del perfil, imágenes y demás
        contenidos deberán cumplir estas Normas y los Términos de Uso de
        pregnancy&baby.
      </PolicyText>

      <PolicySectionTitle>
        3. Denuncia de contenidos inapropiados o ilícitos
      </PolicySectionTitle>
      <PolicyText>
        Si encuentras una publicación o comentario que consideres contrario a
        estas Normas —por ejemplo, spam, publicidad no autorizada, acoso,
        insultos u otros contenidos inapropiados— puedes utilizar la función{" "}
        <strong>Denunciar</strong> disponible en el Servicio.
      </PolicyText>
      <PolicyText>
        Cuando se trate de contenido que consideres ilícito, también podrás
        comunicarlo a través de los mecanismos de denuncia disponibles en el
        Servicio.
      </PolicyText>
      <PolicyText>
        Las denuncias de las personas usuarias nos ayudan a mantener una
        comunidad más segura y respetuosa.
      </PolicyText>
      <PolicyText>
        La Empresa podrá revisar el contenido denunciado y adoptar las medidas
        correspondientes de acuerdo con estas Normas, los Términos de Uso y la
        legislación aplicable.
      </PolicyText>

      <PolicySectionTitle>
        4. Contenidos y conductas no permitidos
      </PolicySectionTitle>
      <PolicyText>
        Los siguientes contenidos y conductas no están permitidos en la
        comunidad de pregnancy&baby.
      </PolicyText>

      <PolicyArticleTitle>4.1 Contenido sexual u obsceno</PolicyArticleTitle>
      <PolicyText>No publiques contenidos que:</PolicyText>
      <PolicyHyphenList>
        <li>
          Incluyan imágenes o descripciones sexuales excesivamente explícitas,
          obscenas o inapropiadas;{" "}
        </li>
        <li>
          Promuevan, soliciten, intermedien o faciliten la prostitución o
          servicios sexuales ilícitos;{" "}
        </li>
        <li>
          Tengan como finalidad humillar, acosar u ofender sexualmente a otra
          persona; o{" "}
        </li>
        <li>
          Incluyan explotación sexual u otros contenidos sexuales ilícitos.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.2 Actividades o transacciones ilícitas
      </PolicyArticleTitle>
      <PolicyText>No utilices la comunidad para:</PolicyText>
      <PolicyHyphenList>
        <li>Promover o facilitar actividades de juego o apuestas ilegales; </li>
        <li>
          Vender, comprar, intercambiar u ofrecer bienes o servicios
          ilícitos;{" "}
        </li>
        <li>
          Vender o promocionar productos cuya comercialización en línea esté
          prohibida por la legislación aplicable; o{" "}
        </li>
        <li>
          Facilitar información destinada a promover, ayudar o facilitar
          actividades ilícitas.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        El concepto de contenido ilícito en la UE es amplio y puede incluir
        información relacionada con bienes, servicios y actividades ilegales,
        además del propio contenido ilegal.
      </PolicyText>

      <PolicyArticleTitle>
        4.3 Contenido dañino, violento o perturbador
      </PolicyArticleTitle>
      <PolicyText>No publiques contenidos que:</PolicyText>
      <PolicyHyphenList>
        <li>
          Incluyan imágenes o descripciones excesivamente gráficas, violentas,
          macabras o perturbadoras, incluidas imágenes explícitas de lesiones
          graves o fallecimientos;{" "}
        </li>
        <li>Incluyan o faciliten la explotación sexual; </li>
        <li>
          Amenacen, coaccionen, engañen o capten a otra persona con fines de
          explotación sexual;{" "}
        </li>
        <li>Promuevan, fomenten o glorifiquen la violencia; </li>
        <li>
          Promuevan la discriminación, el odio o los prejuicios contra una
          persona o grupo por motivos como nacionalidad, origen, raza,
          discapacidad, enfermedad, sexo, identidad de género, orientación
          sexual u otras características personales; o{" "}
        </li>
        <li>
          Promuevan, fomenten o faciliten el suicidio o el suicidio colectivo.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.4 Publicidad, promoción y captación comercial
      </PolicyArticleTitle>
      <PolicyText>
        La publicidad comercial, las actividades promocionales, la captación de
        clientes y el spam no autorizados por la Empresa podrán ser restringidos
        o eliminados.
      </PolicyText>
      <PolicyText>Esto puede incluir:</PolicyText>
      <PolicyHyphenList>
        <li>
          Publicar repetidamente contenidos publicitarios o promocionales
          idénticos o similares;{" "}
        </li>
        <li>
          Publicaciones cuyo objetivo principal sea promocionar productos o
          servicios;{" "}
        </li>
        <li>
          Contenidos destinados a dirigir a las personas usuarias hacia
          actividades comerciales o transacciones externas no autorizadas;
          o{" "}
        </li>
        <li>
          Utilizar principalmente la comunidad para vender productos o
          servicios, captar clientes o realizar actividades de marketing.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        La Empresa no participa ni garantiza las transacciones que las personas
        usuarias realicen voluntariamente entre sí como consecuencia de
        publicaciones o interacciones dentro de la comunidad, salvo cuando la
        legislación aplicable disponga otra cosa.
      </PolicyText>
      <PolicyText>
        Si detectas una actividad comercial o promocional sospechosa, utiliza la
        función Denunciar disponible en el Servicio.
      </PolicyText>

      <PolicyArticleTitle>
        4.5 Acoso, insultos, difamación y suplantación de identidad
      </PolicyArticleTitle>
      <PolicyText>No está permitido:</PolicyText>
      <PolicyHyphenList>
        <li>
          Insultar, amenazar, acosar o atacar repetidamente a otra persona;{" "}
        </li>
        <li>
          Utilizar expresiones gravemente ofensivas, degradantes o abusivas
          dirigidas contra otra persona usuaria;{" "}
        </li>
        <li>
          Suplantar la identidad de pregnancy&baby, la Empresa, sus empleados,
          administradores u otras personas;{" "}
        </li>
        <li>
          Falsear la propia identidad o condición con el fin de engañar a otras
          personas usuarias u obtener un beneficio indebido;{" "}
        </li>
        <li>
          Difundir deliberadamente información falsa o engañosa sobre una
          persona u organización de forma que pueda causarle un perjuicio;
          o{" "}
        </li>
        <li>
          Publicar contenidos falsos presentándolos como noticias, informaciones
          periodísticas o comunicaciones oficiales auténticas con el fin de
          inducir a error.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.6 Software malicioso e interferencias con el Servicio
      </PolicyArticleTitle>
      <PolicyText>No está permitido:</PolicyText>
      <PolicyHyphenList>
        <li>
          Subir, distribuir o enlazar virus, malware, código malicioso u otros
          programas destinados a dañar o interferir con dispositivos o
          sistemas;{" "}
        </li>
        <li>
          Interferir o alterar deliberadamente el funcionamiento normal de
          pregnancy&baby;{" "}
        </li>
        <li>Aprovechar vulnerabilidades del Servicio; o </li>
        <li>
          Utilizar métodos automatizados o no autorizados para distribuir
          publicidad, promociones, solicitudes de contacto, solicitudes de
          interacción u otros contenidos similares.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.7 Infracción de derechos de propiedad intelectual
      </PolicyArticleTitle>
      <PolicyText>
        Respeta los derechos de propiedad intelectual de otras personas.
      </PolicyText>
      <PolicyText>No está permitido:</PolicyText>
      <PolicyHyphenList>
        <li>
          Utilizar sin autorización obras, marcas, diseños, imágenes u otros
          materiales protegidos pertenecientes a terceros;{" "}
        </li>
        <li>
          Compartir emisiones, música, películas, animaciones, fotografías,
          imágenes, artículos, publicaciones u otras obras sin la autorización
          correspondiente;{" "}
        </li>
        <li>
          Facilitar instrucciones o información destinadas a permitir el acceso
          o uso ilícito de contenidos protegidos por derechos de autor; o{" "}
        </li>
        <li>
          Copiar o volver a publicar sin permiso publicaciones, fotografías o
          imágenes de otras personas usuarias de pregnancy&baby cuando ello
          vulnere sus derechos.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        La protección de los derechos de autor y otros derechos de propiedad
        intelectual continúa aplicándose específicamente en el marco europeo de
        servicios digitales.
      </PolicyText>

      <PolicyArticleTitle>
        4.8 Datos personales y traslado de conversaciones fuera del Servicio
      </PolicyArticleTitle>
      <PolicyText>
        Para proteger la privacidad y seguridad de las personas usuarias, no
        está permitido:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Solicitar datos personales de otra persona usuaria mediante
          publicaciones o comentarios;{" "}
        </li>
        <li>
          Publicar datos personales propios o de terceros de una forma que pueda
          generar riesgos para la privacidad o la seguridad; o{" "}
        </li>
        <li>
          Animar de forma reiterada o inapropiada a otras personas usuarias a
          trasladar las conversaciones a redes sociales, aplicaciones de
          mensajería u otros canales externos al Servicio.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Cuando compartas información en la comunidad, recuerda que otros
        miembros podrán tener acceso a ella.
      </PolicyText>

      <PolicyArticleTitle>
        4.9 Spam y otras conductas que alteren la comunidad
      </PolicyArticleTitle>
      <PolicyText>No está permitido:</PolicyText>
      <PolicyHyphenList>
        <li>
          Publicar repetidamente contenidos idénticos o sustancialmente
          similares;{" "}
        </li>
        <li>
          Publicar el mismo contenido o contenidos similares en múltiples áreas
          del Servicio;{" "}
        </li>
        <li>Manipular o utilizar indebidamente las funciones del Servicio; </li>
        <li>
          Interferir deliberadamente con el uso normal del Servicio por parte de
          otras personas usuarias; o{" "}
        </li>
        <li>
          Realizar cualquier otra conducta que altere de manera significativa el
          funcionamiento normal de la comunidad.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Aunque una conducta no esté expresamente incluida en estas Normas, podrá
        ser restringida cuando afecte claramente a la seguridad, integridad o
        funcionamiento normal del Servicio o interfiera de manera significativa
        con el uso del Servicio por parte de otras personas.
      </PolicyText>

      <PolicySectionTitle>
        5. Moderación y gestión de contenidos
      </PolicySectionTitle>
      <PolicyText>
        Cuando un contenido infrinja la legislación aplicable, los Términos de
        Uso de pregnancy&baby o estas Normas, la Empresa podrá adoptar una o
        varias de las siguientes medidas:
      </PolicyText>
      <PolicyHyphenList>
        <li>Limitar la visibilidad del contenido; </li>
        <li>Ocultar temporalmente el contenido; </li>
        <li>Eliminar el contenido; </li>
        <li>Limitar temporalmente la posibilidad de publicar o comentar; </li>
        <li>
          Restringir el acceso a determinadas funciones de la comunidad; o{" "}
        </li>
        <li>
          Adoptar otras medidas razonablemente necesarias para evitar la
          continuación de la infracción o daños adicionales.{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        La Empresa no está obligada a revisar previamente todos los contenidos
        publicados por las personas usuarias.
      </PolicyText>
      <PolicyText>
        El hecho de que un contenido permanezca visible en el Servicio no
        significa que la Empresa lo haya aprobado, recomendado, garantizado o
        verificado.
      </PolicyText>
      <PolicyText>
        Cuando corresponda conforme a la legislación aplicable, la Empresa
        proporcionará a la persona usuaria afectada información sobre los
        motivos de una decisión de moderación.
      </PolicyText>

      <PolicySectionTitle>
        6. Restricciones de la Cuenta y del uso del Servicio
      </PolicySectionTitle>
      <PolicyText>
        Si una persona usuaria infringe la legislación aplicable, los Términos
        de Uso o estas Normas, la Empresa podrá restringir su acceso a
        determinadas funciones o Servicios.
      </PolicyText>
      <PolicyText>
        Las restricciones podrán ser temporales o permanentes dependiendo de la
        naturaleza, gravedad y frecuencia de la infracción.
      </PolicyText>
      <PolicyText>Las medidas podrán incluir:</PolicyText>
      <PolicyHyphenList>
        <li>Advertencias; </li>
        <li>Limitación de la visibilidad de los contenidos; </li>
        <li>Eliminación de contenidos; </li>
        <li>Restricción temporal de la posibilidad de publicar o comentar; </li>
        <li>Restricción del acceso a funciones de la comunidad; </li>
        <li>Suspensión temporal de la Cuenta; o </li>
        <li>
          Restricción o suspensión permanente de la Cuenta en casos de
          infracciones graves.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        La Empresa podrá adoptar inmediatamente las medidas necesarias sin
        aplicar restricciones progresivas cuando resulte razonablemente
        necesario, especialmente en casos relacionados con actividades ilícitas
        graves, explotación sexual, juego ilegal, riesgos graves para la
        seguridad, ataques maliciosos contra el Servicio u otras infracciones
        graves.
      </PolicyText>
      <PolicyText>
        La Empresa también podrá adoptar medidas de protección razonables cuando
        detecte actividad anómala de la Cuenta, intentos de acceso no
        autorizado, abuso automatizado u otras actividades que puedan poner en
        riesgo a las personas usuarias o al Servicio.
      </PolicyText>

      <PolicySectionTitle>
        7. Reclamaciones y solicitud de revisión
      </PolicySectionTitle>
      <PolicyText>
        Si consideras que tu contenido o Cuenta ha sido restringido por error,
        puedes ponerte en contacto con el servicio de Atención al Cliente de
        pregnancy&baby y solicitar una revisión de la decisión.
      </PolicyText>
      <PolicyText>
        La Empresa revisará la solicitud de acuerdo con estas Normas, los
        Términos de Uso y la legislación aplicable.
      </PolicyText>
      <PolicyText>
        Cuando resulte aplicable, también podrán utilizarse otros mecanismos de
        reclamación o resolución de litigios previstos por la legislación
        aplicable.
      </PolicyText>
      <PolicyText>
        <strong>Atención al Cliente: after10month@connect-i.co.kr</strong>
      </PolicyText>

      <PolicySectionTitle>
        8. Relación con los Términos de Uso
      </PolicySectionTitle>
      <PolicyText>
        Estas Normas forman parte de las reglas aplicables al uso de
        pregnancy&baby y deberán leerse y aplicarse conjuntamente con los{" "}
        <strong>Términos de Uso de pregnancy&baby</strong>.
      </PolicyText>
      <PolicyText>
        Las cuestiones que no estén específicamente reguladas en estas Normas se
        tratarán de acuerdo con los Términos de Uso, la legislación aplicable y
        las demás políticas aplicables de la Empresa.
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationEs;
